<template>
  <div id="app">
    <nav-bar-top />
    <div class="body text-left">
      <div class="flex flex-no-wrap">
        <nav-bar />
        <router-view />
      </div>
      <Footer/> 
    </div>
  </div>
</template>

<script>
/* import { onBeforeMount } from 'vue'
import { useStore } from 'vuex' */
import Vue from 'vue';
import Buefy from 'buefy';

 import Footer from './components/Footer.vue'
 import axios from 'axios';

 Vue.use(Buefy);

export default {
  name: 'App',
  components: {
     Footer
  },
  data: () => ({
    logoutTime: 10 * 60 * 1000,
      user: JSON.parse(localStorage.getItem("user")) || { role: { name: 0 } },
      dialogInstance: null,
      intervalId: null,
      logoutTimeout: null
  }),
  setup() {

  },
  mounted() {
    //this.checkForNewDeployment();
    // Add event listeners
    console.log("mounted")

   
  },
  created() {
    console.log("created");
    // const token = localStorage.getItem('token');
    // if (token && this.user.role.name > 0) {
    //   console.log("start the timer");
    //   this.startLogoutTimer();
    //   document.addEventListener("scroll", this.resetIdleTimer);
    //   document.addEventListener("mousemove", this.resetIdleTimer);
    //   document.addEventListener("keypress", this.resetIdleTimer);
    // }
  },
  updated(){
    console.log("updated")
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.resetIdleTimer);
    document.removeEventListener("mousemove", this.resetIdleTimer);
    document.removeEventListener("keypress", this.resetIdleTimer);
    this.clearLogoutTimer();
  },
  computed: {
    isButtonUpdated() {
      return this.$store.state.isButtonUpdated;
    },
    // reduceLogoutTime() {
    // return this.logoutTime - 60000
    // },
  },
  methods: {
    resetIdleTimer() {
      this.logoutTime = 10 * 60 * 1000;
      this.dialogInstance = null;
      this.startLogoutTimer();
    },
    startLogoutTimer() {
      let hasOneMinuteElapsed = false;
      this.logoutTimeout = setTimeout(() => {
        hasOneMinuteElapsed = true;
        this.logout();
      }, this.logoutTime);

      if (!hasOneMinuteElapsed) {
        setTimeout(() => {
          this.intervalId = setInterval(() => {
            this.reduceLogoutTime();
          }, 60000);
        }, 60000);
      }
    },
    clearLogoutTimer() {
      clearTimeout(this.logoutTimeout);
      clearInterval(this.intervalId);
    },
    reduceLogoutTime() {
      this.logoutTime -= 60000;
      this.showLogoutWarning();
    },
    showLogoutWarning() {
      if (this.dialogInstance) {
        this.dialogInstance.close();
      }

      this.dialogInstance = this.$buefy.dialog.confirm({
        title: 'Session wird beendet',
        message: `Du wirst in ${this.logoutTime / 1000 / 60} Minuten ausgeloggt.`,
        cancelText: 'Logout',
        confirmText: 'Weiter arbeiten',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          this.clearLogoutTimer();
          this.logoutTime = 10 * 60 * 1000;
          this.startLogoutTimer();
          this.$buefy.toast.open('Happy Authoring!');
        },
        onCancel: () => {
          this.$buefy.toast.open('Sie werden ausgeloggt!');
          this.logout();
        }
      });
    },
    async logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");

      this.clearLogoutTimer();

      document.removeEventListener("scroll", this.resetIdleTimer);
      document.removeEventListener("mousemove", this.resetIdleTimer);
      document.removeEventListener("keypress", this.resetIdleTimer);

      this.$router.go("/");
    },
    async checkForNewDeployment() {
      try {
        const response = await axios.get(
          'https://api.vercel.com/v12/projects/prj_UTy70V7nhmWII27CbXgqxbwGcTZj/deploys',
          {
            headers: {
              Authorization: `Bearer ${process.env.VERCEL_ACCESS_TOKEN}`,
            },
          }
        );
    
        // Check if there are any deployments after the current one
        const currentDeploymentTime = new Date(process.env.NOW_DATE).getTime();
        const newDeployments = response.data.filter(
          (deployment) =>
            new Date(deployment.created).getTime() > currentDeploymentTime
        );
    
        // Update the button if there are new deployments
        if (newDeployments.length > 0) {
          this.$store.commit('updateButtonStatus', true); // Commit mutation to update isButtonUpdated to true
        } else {
          this.$store.commit('updateButtonStatus', false); // Commit mutation to update isButtonUpdated to false
        }
      } catch (error) {
        console.error('Error checking for new deployments:', error);
      }
    }
  }

}
</script>


<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

</style>